"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAudit extends new_item_1.default {
    constructor(newAudit) {
        super();
        this.installerAccountId = newAudit.installerAccountId;
        this.installingForId = newAudit.installingForId;
        this.installerName = newAudit.installerName;
        this.installerOrgName = newAudit.installerOrgName;
        this.siteName = newAudit.siteName;
        this.siteId = newAudit.siteId;
        this.issues = newAudit.issues;
        this.warningLevel = newAudit.warningLevel;
        this.createdDate = newAudit.createdDate;
        this.message = newAudit.message;
        this.devices = newAudit.devices;
        this.gateways = newAudit.gateways;
        this.files = newAudit.files;
        this.warningLevelDevices = newAudit.warningLevelDevices;
        this.zeroDemandDevices = newAudit.zeroDemandDevices;
        this.disconnectedDevices = newAudit.disconnectedDevices;
        this.disconnectedGateways = newAudit.disconnectedGateways;
        this.warningLevelGateways = newAudit.warningLevelGateways;
        this.warningLevelFiles = newAudit.warningLevelFiles;
    }
}
exports.default = NewAudit;
//# sourceMappingURL=new-audit.js.map